import { ReduxStore } from "etl/core";
import { Provider } from "react-redux";

export interface WithReduxProps {
	children: React.ReactNode
	store: ReduxStore
}

export const WithRedux = (props: WithReduxProps) => {
	const { children, store } = props
	return <Provider store={store}>{children}</Provider>
}
